/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import {
  STATEPROVINCEDATA_LOAD,
  STATEPROVINCEDATA_LOAD_SUCCESS,
  STATEPROVINCEDATA_LOAD_FAILURE,
  STATEPROVINCESHIPPING_LOAD,
  STATEPROVINCESHIPPING_LOAD_SUCCESS,
  STATEPROVINCESHIPPING_LOAD_FAILURE,
  STATEPROVINCESCHOOL_LOAD,
  STATEPROVINCESCHOOL_LOAD_SUCCESS,
  STATEPROVINCESCHOOL_LOAD_FAILURE,
} from "../../Constants/ActionTypes";
import { IStateProvinceData } from "../../Interfaces/SiteContent";

/**
 *
 */
export interface IGetStateProvince {
  type: typeof STATEPROVINCEDATA_LOAD;
  countryRegionName: string;
}

/**
 *
 */
export interface IGetStateProvinceSuccess {
  type: typeof STATEPROVINCEDATA_LOAD_SUCCESS;
  stateProvinces: IStateProvinceData[];
}

/**
 *
 */
export interface IGetStateProvinceFailure {
  type: typeof STATEPROVINCEDATA_LOAD_FAILURE;
  stateProvincesLoadError: string;
}

/**
 *
 */
export interface IGetStateProvinceShipping {
  type: typeof STATEPROVINCESHIPPING_LOAD;
  countryRegionName: string;
}

export interface IGetStateProvinceShippingSuccess {
  type: typeof STATEPROVINCESHIPPING_LOAD_SUCCESS;
  stateProvincesShipping: IStateProvinceData[];
}

/**
 *
 */
export interface IGetStateProvinceShippingFailure {
  type: typeof STATEPROVINCESHIPPING_LOAD_FAILURE;
  stateProvincesShippingLoadError: string;
}

/**
 *
 */
export interface IGetStateProvinceSchool {
  type: typeof STATEPROVINCESCHOOL_LOAD;
  countryRegionName: string;
}

/**
 *
 */
export interface IGetStateProvinceSchoolSuccess {
  type: typeof STATEPROVINCESCHOOL_LOAD_SUCCESS;
  stateProvincesSchool: IStateProvinceData[];
}

/**
 *
 */
export interface IGetStateProvinceSchoolFailure {
  type: typeof STATEPROVINCESCHOOL_LOAD_FAILURE;
  stateProvincesSchoolLoadError: string;
}

/**
 *
 * @param countryRegionName
 */
export const getStateProvince = (countryRegionName: string): StateProvinceActionTypes => ({
  type: STATEPROVINCEDATA_LOAD,
  countryRegionName,
});

/**
 *
 * @param stateProvinceData
 */
export const getStateProvinceSuccess = (
  stateProvinceData: IStateProvinceData[]
): StateProvinceActionTypes => ({
  type: STATEPROVINCEDATA_LOAD_SUCCESS,
  stateProvinces: stateProvinceData,
});

/**
 *
 * @param errorMessage
 */
export const getStateProvinceFailure = (
  stateProvincesLoadError: string
): StateProvinceActionTypes => ({
  type: STATEPROVINCEDATA_LOAD_FAILURE,
  stateProvincesLoadError,
});

/**
 *
 * @param countryRegionName
 */
export const getStateProvinceShipping = (countryRegionName: string): StateProvinceActionTypes => ({
  type: STATEPROVINCESHIPPING_LOAD,
  countryRegionName,
});

/**
 *
 * @param stateProvinceData
 */
export const getStateProvinceShippingSuccess = (
  stateProvinceData: IStateProvinceData[]
): StateProvinceActionTypes => ({
  type: STATEPROVINCESHIPPING_LOAD_SUCCESS,
  stateProvincesShipping: stateProvinceData,
});

/**
 *
 * @param errorMessage
 */
export const getStateProvinceShippingFailure = (
  stateProvincesShippingLoadError: string
): StateProvinceActionTypes => ({
  type: STATEPROVINCESHIPPING_LOAD_FAILURE,
  stateProvincesShippingLoadError,
});

/**
 *
 * @param countryRegionName
 */
export const getStateProvinceSchool = (countryRegionName: string): StateProvinceActionTypes => ({
  type: STATEPROVINCESCHOOL_LOAD,
  countryRegionName,
});

/**
 *
 * @param stateProvinceData
 */
export const getStateProvinceSchoolSuccess = (
  stateProvinceData: IStateProvinceData[]
): StateProvinceActionTypes => ({
  type: STATEPROVINCESCHOOL_LOAD_SUCCESS,
  stateProvincesSchool: stateProvinceData,
});

/**
 *
 * @param errorMessage
 */
export const getStateProvinceSchoolFailure = (
  stateProvincesSchoolLoadError: string
): StateProvinceActionTypes => ({
  type: STATEPROVINCESCHOOL_LOAD_FAILURE,
  stateProvincesSchoolLoadError,
});

export type StateProvinceActionTypes =
  | IGetStateProvince
  | IGetStateProvinceSuccess
  | IGetStateProvinceFailure
  | IGetStateProvinceShipping
  | IGetStateProvinceShippingSuccess
  | IGetStateProvinceShippingFailure
  | IGetStateProvinceSchool
  | IGetStateProvinceSchoolSuccess
  | IGetStateProvinceSchoolFailure;
